import TheWorkingMan from '../Assets/Images/TheWorkingMan.png';
import React from 'react';

function WorkInProgrog(){
    return(
        
        <div>
            <header className='App-header'>
            <img src={TheWorkingMan} className="App-logo" alt="TheWorkingMan" />
            <p>
              Work in Progress for more info go to
            </p>
            <a
              className="App-link"
              href="https://obesquito.itch.io/mark-of-the-knights"
              target="_blank"
              rel="noopener noreferrer"
            >
              Mark Of the knights (our itch page)
            </a>
          </header>
        </div>
    
    )
}


export default WorkInProgrog